export const getInventoryInvoiceList = state => {
    return state.list
}

export const getInventoryInvoiceOutstandingList = state => {
    return state.outstanding_list
}

export const getInventoryInvoiceDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryInvoice/getters.js